
function addItemToCart() {
    const formData = $('#product-main-form').serialize();
    let quantity = formData.split("quantity=")[1];
    if (quantity.length > 4) {
        // Must have additional input values, get the quantity value only before the next &param=
        quantity = quantity.split("&")[0];
    }

    quantity = parseInt(quantity);

    $.ajax({
       type: 'POST',
       url: '/cart/add.js',
       dataType: 'json',
       data: formData,
       success: function(data) {
            addToCartOk(data, quantity);
       },
       error: addToCartFail
    });
}

function addonItemToCart() {
    const formData = $('#product-addon-form').serialize();
    let quantity = formData.split("quantity=")[1];
    if (quantity.length > 4) {
        // Must have additional input values, get the quantity value only before the next &param=
        quantity = quantity.split("&")[0];
    }

    quantity = parseInt(quantity);

    $.ajax({
       type: 'POST',
       url: '/cart/add.js',
       dataType: 'json',
       data: formData,
       success: function(data) {
            addonToCartOk(data, quantity);
       },
       error: addToCartFail
    });
}

function addToCartOk(product, quantity) {
  console.log(product);

   const productPrice = (product.final_price / 100).toFixed(2); // e.g. 2200 to 22.00

   $('.cart-preview-modal-content').html('<div><div style="font-size: 14px;">Added to Basket!</div><h3 style="margin-top: 5px; margin-bottom: 5px; font-weight: 700; color: #000000;">' + product.title + '</h3><div style="font-weight: bold; color: #000000;"><span style="margin-right: 20px;"><span style="font-size: 24px; color:#f77907;">£' + productPrice + '</span> EXC. VAT</span>QTY: ' + product.quantity + '</div></div>');
   $('.cart-preview-modal-bottom').html('<div><a href="/cart" class="view-basket-button">VIEW BASKET</a><a onClick="closeModal();" class="continue-shopping-button">CONTINUE SHOPPING</a></div>');

   openModal();

   // Update cart count bubble in header
   $('.cart-count-bubble').css("visibility", "visible");

   if ($('.cart-count-bubble span').text().length) {
      let cartCount = parseInt($('.cart-count-bubble span').text());
      $('.cart-count-bubble span').text( cartCount + quantity );
   } else {
       $('.cart-count-bubble span').text(quantity);
   }

}

function addonToCartOk(product, quantity) {
    $('#addon-button-text').text('ADDED');
    $('.view-item-button').prop('disabled', true); 

   // Update cart count bubble in header
   $('.cart-count-bubble').css("visibility", "visible");

   if ($('.cart-count-bubble span').text().length) {
      let cartCount = parseInt($('.cart-count-bubble span').text());
      $('.cart-count-bubble span').text( cartCount + quantity );
   } else {
       $('.cart-count-bubble span').text(quantity);
   }

}

function addToCartFail(obj, status) {
   $('.cart-preview-modal-content').html('<h2 style="margin-top: 4px; margin-bottom: 15px; font-weight: 700; color: #000000;">Sorry, this product is not available currently.</h2>');
   openModal();
}

function openModal(){
   $('.cart-preview-modal').removeClass('hidden').addClass('open');
}

function closeModal(){
   $('.cart-preview-modal.open').addClass('hidden').removeClass('open');
}
